document.querySelector("html").classList.remove("no-js");

const body = document.querySelector("body");
const html = document.querySelector("html");

const mq = window.matchMedia("(min-width: 800px)");

const togglePopoverSupported = typeof body.hidePopover === "function";



if (togglePopoverSupported) {
  isPopoverSupported = true;
} else {
  html.classList.add("no-popover");
  isPopoverSupported = false;
}
// console.log("Popover supported:", isPopoverSupported);

const indexCheck = document
  .querySelector("body")
  .classList.contains("template-index");
const productCheck = document
  .querySelector("body")
  .classList.contains("template-product");
const collectionCheck = document
  .querySelector("body")
  .classList.contains("template-collection");
const searchCheck = document
  .querySelector("body")
  .classList.contains("template-search");
const blogCheck = document
  .querySelector("body")
  .classList.contains("template-blog");
  const galleryCheck = document.querySelector("body").classList.contains("suffix-gallery");
const annBarCheck = document.querySelector(".announcement-bar") !== null;

const formCheck = document.getElementById("add-to-cart-form") !== null;
const qtyCheck = document.querySelector(".js-quantity-picker") !== null;
const lineQtyCheck = document.querySelector("quantity-selector") !== null;
const instaCheck = document.querySelector(".section-instagram-feed") !== null;
const gridSectionCheck = document.querySelector(".grid-slider") !== null;
const sizeGuideCheck = document.querySelector(".size-guide__link") !== null;
 
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

function checkedToCheckbox() {
  let checkboxs = document.querySelectorAll("input");
      
  checkboxs.forEach((input) => {
    if (input.checked) {
      input.setAttribute("checked", true);
    } else {
      input.removeAttribute("checked");
    }

    input.addEventListener("change", function (event) {
      if (input.checked) {
        input.setAttribute("checked", true);
      } else {
        input.removeAttribute("checked");
      }
    });
  });
}


function toggleExpandedEls() {
  // Select all elements with the 'aria-expanded' attribute
  const expandableElements = document.querySelectorAll("[aria-expanded]");

  const toggleExpanded = (element) => {
    const isExpanded = element.getAttribute("aria-expanded") === "true";

    // Toggle aria-expanded
    element.setAttribute("aria-expanded", String(!isExpanded));
    // If the element has a data-target attribute, toggle aria-hidden on the target
    const targetSelector = element.getAttribute("popovertarget");

    if (targetSelector) {
      const popoverModal = document.getElementById(targetSelector);

      if (popoverModal) {
        popoverModal.addEventListener("beforetoggle", (event) => {
          if (event.newState === "open") {
            popoverModal.setAttribute("aria-hidden", false);
            element.setAttribute("aria-expanded", true);
            console.log("Popover has been shown");
          } else {
            console.log("Popover has been hidden");
            element.setAttribute("aria-expanded", false);
            popoverModal.setAttribute("aria-hidden", true);
          }
        });
      }
    }
  };

  // Add click event listener to each element with debounce
  const debouncedToggleExpanded = debounce(toggleExpanded, 300);
  expandableElements.forEach((element) => {
    element.addEventListener("click", () => debouncedToggleExpanded(element));
  });
}

// Widths
const px800 = window.innerWidth <= 800;

if (
  navigator.userAgent.indexOf("Safari") != -1 &&
  navigator.userAgent.indexOf("Chrome") == -1
) {
  body.classList.add("browser-safari");
}



// Reccomendations
function reccs() {
  const productRecommendationsSection = document.querySelector(
    "section.recommendations"
  );

  if (!productRecommendationsSection) return;

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(".recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          // Dispatch custom event
          document.dispatchEvent(new CustomEvent("recommendationsLoaded"));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: "0px 0px 200px 0px",
  });

  observer.observe(productRecommendationsSection);
}

if (productCheck) {
  reccs();
}

document.addEventListener('recommendationsLoaded', () => {
  console.log('Recommendations loaded');
 
  document.querySelector('.quick-add-to-cart-button-popover').addEventListener('click', () => {
    console.log('Quick add to cart button clicked');
    cartScripts();
  });
});

// Intersection Observer
function intObs() {
  let observerSelector = ".observed",
    observerObject = document.querySelectorAll(observerSelector),
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.1) {
            entry.target.classList.add("in-view");
            entry.target.classList.remove("out-of-view");
            setTimeout(() => {
              entry.target.classList.add("viewed");
            }, 800);
          } else {
            entry.target.classList.remove("in-view");
            entry.target.classList.add("out-of-view");
          }
        });
      },
      {
        threshold: [0, 0.1, 1],
      }
    );

  observerObject.forEach((holder) => {
    observer.observe(holder);
  });

  window.addEventListener("resize", function () {
    observerObject.forEach((holder) => {
      observer.observe(holder);
    });
  });
}

let isMiniCartOpen = false,
    wasTransparent = false,
    isSearchOpen = false,
    isMenuOpen = false;

// // Open cart on page load if ?cart=open is in the URL
// if (new URLSearchParams(window.location.search).get('cart') === 'open') {
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', openMiniCart);
//   } else {
//     openMiniCart();
//   }
// }

function syncMiniCartAria(isOpen) {
  const miniCartElement = document.getElementById("mini-cart");
  const miniCartButtons = document.querySelectorAll(".js-cart");

  if (miniCartElement) {
    miniCartElement.setAttribute("aria-hidden", String(!isOpen));
  }

  miniCartButtons.forEach((button) => {
    button.setAttribute("aria-expanded", String(isOpen));
    button.setAttribute("aria-label", isOpen ? "Close cart" : "Open cart");
  });
}

function syncSearchAriaState(isOpen) {
  const searchModalElement = document.getElementById("search-modal");
  const searchButtons = document.querySelectorAll(".js-search");

  if (searchModalElement) {
    searchModalElement.setAttribute("aria-hidden", String(!isOpen));
  }

  searchButtons.forEach((button) => {
    button.setAttribute("aria-expanded", String(isOpen));

    if (!button.classList.contains("search-modal__close")) {
      button.setAttribute("aria-label", isOpen ? "Close Search" : "Open Search");
    }
  });
}

function closeMiniCart() {
  const root = document.documentElement;
  const header = document.querySelector("header");

  root.classList.remove("mini-cart-open");
  syncMiniCartAria(false);
  isMiniCartOpen = false;

  // const url = new URL(window.location);
  // url.searchParams.delete('cart');
  // window.history.replaceState({}, '', url);

  if (wasTransparent && header) {
    header.classList.add("transparent--visible");
  }
}

function openMiniCart() {
  const root = document.documentElement;
  const header = document.querySelector("header");

  if (isHeaderTransparent) {
    wasTransparent = true;
  } else {
    wasTransparent = false;
  }

  if (isMenuOpen) {
    root.classList.remove("menu-active");
    isMenuOpen = false;
  }

  if (isSearchOpen) {
    root.classList.remove("search-active");
    syncSearchAriaState(false);
    isSearchOpen = false;
  }

  root.classList.add("mini-cart-open");
  syncMiniCartAria(true);

  if (wasTransparent && header) {
    header.classList.remove("transparent--visible");
  }

  isMiniCartOpen = true;

  // const url = new URL(window.location);
  // url.searchParams.set('cart', 'open');
  // window.history.replaceState({}, '', url);
}

function onMiniCartClick(button) {
  if (button.dataset.miniCartListenerAdded === "true") {
    return;
  }

  // console.log("onMiniCartClick called for button:", button);

  button.addEventListener("click", function (event) {
    event.preventDefault();

    if (isMiniCartOpen) {
      closeMiniCart();
    } else {
      openMiniCart();
    }
  });
  button.dataset.miniCartListenerAdded = "true";

}

function miniCart() {
  const miniCartButtons = document.querySelectorAll(".js-cart"),
      miniCartButton = document.querySelector(".js-cart");

    if (miniCartButtons.length > 0) {
      console.log("Multiple Mini Cart Buttons");
      miniCartButtons.forEach((button) => {
        onMiniCartClick(button);
      });
    } else {
      console.log("Single Mini Cart Button");
        onMiniCartClick(miniCartButton);
    }

  document.removeEventListener("click", onDocumentClickToCloseCart);
  document.addEventListener("click", onDocumentClickToCloseCart);

  document.removeEventListener("keydown", onMiniCartEscape);
  document.addEventListener("keydown", onMiniCartEscape);

  syncMiniCartAria(isMiniCartOpen);
}


function onDocumentClickToCloseCart(event) {
  const miniCartElement = document.getElementById("mini-cart");
  const addToCartButtonLink = document.querySelector(".add-to-cart-button .confirmation-message");

  if (!isMiniCartOpen) {
    return;
  }

  if (addToCartButtonLink && (event.target === addToCartButtonLink || addToCartButtonLink.contains(event.target))) {
    return;
  }

  if (event.target.closest(".js-cart")) {
    return;
  }

  if (miniCartElement && miniCartElement.contains(event.target)) {
    return;
  }

  closeMiniCart();
}

function onMiniCartEscape(event) {
  if (event.key === "Escape" && isMiniCartOpen) {
    closeMiniCart();
  }
}


// Video Icon

// icon-play
// On click video element, play video, hide icon and reveal video controls.

function videoIcon(video) {
  video.addEventListener("click", function (event) {
    event.preventDefault();

    let video = this.querySelector("video"),
      icon = this.querySelector(".icon-play");

    if (video.paused) {
      console.log("play video");
      this.classList.add("is-playing");
      video.play();

      icon.setAttribute("aria-hidden", true);
      icon.setAttribute("aria-label", "Pause video");
      video.setAttribute("controls", "controls");
    } else {
      console.log("pause video");
      this.classList.remove("is-playing");
      video.pause();
      video.removeAttribute("controls");

      icon.setAttribute("aria-hidden", false);
      icon.setAttribute("aria-label", "Play video");
    }
  });
}

document.querySelectorAll(".how-to__media").forEach((video) => {
  videoIcon(video);
});

function megaMenuMouseOver() {
  let megaMenu = document.querySelector(".mega-menu") !== null,
    search = document.querySelector(".header-search");

  // console.log("megaMenuMouseOver");
  // console.log("megaMenu exists");
  let megaMenuLinks = document.querySelectorAll(".megamenu-trigger");

  megaMenuLinks.forEach((link) => {
    link.addEventListener("mouseover", function (event) {
      console.log("mouseover");

      let target = link.getAttribute("data-target"),
        targetEl = document.getElementById(target);

      // if (targetEl) {
      //   targetEl.showPopover();
      //   targetEl.setAttribute("aria-hidden", false);
      //   link.setAttribute("aria-expanded", true);
      // }

      targetEl.addEventListener("mouseleave", function (event) {
        targetEl.hidePopover();
        targetEl.setAttribute("aria-hidden", true);
        link.setAttribute("aria-expanded", false);
      });
    });
  });

  // if (search !== null) {
  //   search.addEventListener("mouseover", function (event) {
  //     let searchInput = search.querySelector(".js-search-input");

  //     if (searchInput) {
  //       searchInput.focus();
  //     }
  //   });

  //   search.addEventListener("mouseleave", function (event) {
  //     let searchInput = search.querySelector(".js-search-input");

  //     search.hidePopover();

  //     if (searchInput) {
  //       searchInput.blur();
  //     }

  //     if (html.classList.contains("search-active")) {
  //       html.classList.remove("search-active");
  //     }
  //   });
  // }
}

function mobileMenuClass() {
  let menuLink = document.querySelector("button.js-menu"),
      html = document.querySelector("html");

  if (!menuLink.dataset.listenerAdded) {
    menuLink.addEventListener("click", function (event) {
      console.log("mobile menu click");
      if (html.classList.contains("menu-active")) {
        html.classList.remove("menu-active");
        this.setAttribute("aria-expanded", "false");
        isMenuOpen = false;
      } else {
        html.classList.add("menu-active");
        this.setAttribute("aria-expanded", "true");
        isMenuOpen = true;
      }
    });
    menuLink.dataset.listenerAdded = "true"; // Mark listener as added
  }
}
    


function quickAddCloseListener () {
  let closers = document.querySelectorAll(".card-product--mini__close");

  closers.forEach((close) => {
    close.addEventListener("click", function (event) {
      event.preventDefault();

      let openPopover = document.querySelector(".quick-add--popover:popover-open"),
          parentPopover = close.closest(".quick-add--popover");

      if (parentPopover) {
        parentPopover.hidePopover();
        parentPopover.setAttribute("aria-hidden", true);
      }
    });
  });
}


function blogFilter() {
  // blog-filter-ajax.js
  const filterContainer = document.querySelector('.custom-filter');
  const blogGridContainer = document.getElementById('blog-grid');

  if (!filterContainer || !blogGridContainer) return;

  console.log('Blog filter AJAX script loaded');


function watchClearButton() {
  let clearButton = document.querySelector('.custom-filter__list__item--all');
  if (!clearButton) return;
  let currentUrl = window.location.href;
  if (currentUrl.indexOf('tagged') !== -1) {
    clearButton.classList.remove('is-active');
  } else {
    clearButton.classList.add('is-active');
  }
}



    



  function reloadFilterAndGrid(url) {
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(res => res.text())
      .then(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const newGrid = tempDiv.querySelector('#blog-grid');
        const newFilter = tempDiv.querySelector('.custom-filter');
        if (newGrid && blogGridContainer) {
          blogGridContainer.replaceWith(newGrid);
        setTimeout(watchClearButton, 0);
        }
        if (newFilter && filterContainer) {
          filterContainer.replaceWith(newFilter);
      setTimeout(watchClearButton, 0);
        }
      });
  }

  filterContainer.addEventListener('click', function (e) {
    const link = e.target.closest('a');
    if (!link || !link.href) return;
    // Only intercept filter links
    if (!link.closest('.custom-filter__list__item')) return;
    e.preventDefault();
    reloadFilterAndGrid(link.href);
    window.history.pushState({}, '', link.href);
   setTimeout(watchClearButton, 0);
  });

  // Handle browser back/forward
  window.addEventListener('popstate', function () {
    reloadFilterAndGrid(window.location.href);
   setTimeout(watchClearButton, 0);
  });
}




function psuedoVariants() {
  const psuedoform = document.querySelector(".psuedo-variant-form");
  const productMain = document.querySelector(".product-main");
  const sectionId = psuedoform?.dataset.sectionId;
  if (!psuedoform || !productMain || !sectionId) return;

  if (!window.history.state || !window.history.state.psuedoUrl) {
    window.history.replaceState({ psuedoUrl: window.location.href }, "", window.location.href);
  }

  let isFetching = false;
  let activeRequestController = null;

  const buildSectionRenderUrl = (url) => {
    const sectionUrl = new URL(url, window.location.origin);
    sectionUrl.searchParams.set("section_id", sectionId);
    return sectionUrl.toString();
  };

  const setLoadingState = (radio, loading) => {
    psuedoform.classList.toggle("is-loading", loading);
    psuedoform.setAttribute("aria-busy", String(loading));

    psuedoform
      .querySelectorAll(".option-values__item--psuedo.is-loading")
      .forEach((item) => item.classList.remove("is-loading"));

    if (radio && loading) {
      radio.closest(".option-values__item--psuedo")?.classList.add("is-loading");
    }
  };

  const getDirectChildBySelector = (parent, selector) => {
    return Array.from(parent.children).find((child) => child.matches(selector));
  };

  const waitForMediaReady = (mediaEl) => {
    if (!mediaEl) return Promise.resolve();

    return new Promise((resolve) => {
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        resolve();
      };

      const tagName = mediaEl.tagName;

      if (tagName === "IMG") {
        if (mediaEl.complete && mediaEl.naturalWidth > 0) {
          finish();
          return;
        }

        mediaEl.addEventListener("load", finish, { once: true });
        mediaEl.addEventListener("error", finish, { once: true });
      } else if (tagName === "VIDEO") {
        if (mediaEl.readyState >= 2) {
          finish();
          return;
        }

        mediaEl.addEventListener("loadeddata", finish, { once: true });
        mediaEl.addEventListener("error", finish, { once: true });
      } else {
        mediaEl.addEventListener("load", finish, { once: true });
        mediaEl.addEventListener("error", finish, { once: true });
      }

      setTimeout(finish, 1400);
    });
  };

  const applyGalleryLoadingState = async () => {
    const galleries = Array.from(productMain.querySelectorAll(".product-main__gallery"));
    const loadingTargets = galleries
      .map((gallery) => {
        const mediaEl = gallery.querySelector(".gallery-media");
        if (!mediaEl) return null;
        return { gallery, mediaEl };
      })
      .filter(Boolean);

    if (!loadingTargets.length) return;

    loadingTargets.forEach(({ gallery }) => {
      gallery.classList.add("is-loading-media");
    });

    await Promise.all(
      loadingTargets.map(async ({ gallery, mediaEl }) => {
        await waitForMediaReady(mediaEl);
        gallery.classList.remove("is-loading-media");
      })
    );
  };

  const replaceScopedProductContent = (nextProductMain) => {
    if (!nextProductMain) return false;

    // Pre-patch the incoming parsed HTML so the checkbox is already checked
    // before any cloneNode(true) copies it into the live DOM.
    if (sessionStorage.getItem("termsAccepted") === "true") {
      const termsInNext = nextProductMain.querySelector("#terms");
      if (termsInNext) {
        termsInNext.checked = true;
        termsInNext.setAttribute("checked", "");
      }
      const btnInNext = nextProductMain.querySelector(".add-to-cart-button");
      if (btnInNext) {
        btnInNext.removeAttribute("disabled");
        btnInNext.classList.remove("disabled--terms-required");
      }
    }

    productMain.className = nextProductMain.className;

    const currentDesktopGallery = productMain.querySelector(".product-main__gallery-container--desktop");
    const nextDesktopGallery = nextProductMain.querySelector(".product-main__gallery-container--desktop");
    if (currentDesktopGallery && nextDesktopGallery) {
      currentDesktopGallery.replaceWith(nextDesktopGallery.cloneNode(true));
    }

    const currentInfo = productMain.querySelector(".product-main__info");
    const nextInfo = nextProductMain.querySelector(".product-main__info");
    if (currentInfo && nextInfo) {
      currentInfo.className = nextInfo.className;

      [
        ".product-main__info__row--title",
        ".product-main__gallery-container--mobile",
        ".product-main__info__row--form",
        ".product-main__secondary.show-desktop",
      ].forEach((selector) => {
        const currentNode = currentInfo.querySelector(selector);
        const nextNode = nextInfo.querySelector(selector);

        if (currentNode && nextNode) {
          currentNode.replaceWith(nextNode.cloneNode(true));
        }
      });
    }

    const currentMobileSecondary = getDirectChildBySelector(productMain, ".product-main__secondary.show-mobile");
    const nextMobileSecondary = getDirectChildBySelector(nextProductMain, ".product-main__secondary.show-mobile");
    if (currentMobileSecondary && nextMobileSecondary) {
      currentMobileSecondary.replaceWith(nextMobileSecondary.cloneNode(true));
    }

    return true;
  };

  async function redirectPsuedo(url, options = {}) {
    const { pushState = true, sourceRadio = null } = options;
    const nextUrl = new URL(url, window.location.origin).toString();

    if (!nextUrl) return;

    if (pushState && nextUrl === window.location.href) return;

    isFetching = true;
    setLoadingState(sourceRadio, true);

    if (activeRequestController) {
      activeRequestController.abort();
    }

    activeRequestController = new AbortController();

    try {
      const response = await fetch(buildSectionRenderUrl(nextUrl), {
        signal: activeRequestController.signal,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });

      if (!response.ok) {
        console.error(`HTTP error! status: ${response.status}`);
        return;
      }

      const data_2 = await response.text();
      let parser = new DOMParser(),
        html = parser.parseFromString(data_2, "text/html");
      const nextProductMain = html.querySelector(".product-main");

      const prevParts = Array.from(
        productMain.querySelectorAll(".product-title__part"),
      ).map((el) => el.dataset.part?.trim());

      if (!replaceScopedProductContent(nextProductMain)) return;

      // Highlight the part that changed compared to the previous title.
      const nextParts = Array.from(
        productMain.querySelectorAll(".product-title__part"),
      );
      nextParts.forEach((el, i) => {
        el.classList.remove("is-changed");
        if (
          prevParts[i] !== undefined &&
          el.dataset.part?.trim() !== prevParts[i]
        ) {
          el.classList.add("is-changed");
          setTimeout(() => el.classList.remove("is-changed"), 1000);
        }
      });

      applyGalleryLoadingState();

      if (pushState) {
        window.history.pushState({ psuedoUrl: nextUrl }, "", nextUrl);
      }

      document.title = html.title || document.title;

      let backLinks = document.querySelectorAll(".js-back");
      if (backLinks) {
        backLinks.forEach((link) => {
          link.href = sessionStorage.getItem("previousUrl");
        });
      }

      if (!mq.matches) {
        const productMainSection = document.querySelector(
          "section.product-main",
        );
        if (productMainSection) {
          const headerHeight =
            parseInt(
              getComputedStyle(document.documentElement).getPropertyValue(
                "--header-height",
              ),
            ) || 0;
          const top =
            productMainSection.getBoundingClientRect().top +
            window.scrollY -
            headerHeight;
          window.scrollTo({ top, behavior: "smooth" });
        }
      }

      cartScripts();

      // Only reinitialize product-specific scripts if we're on a product page
      if (productCheck) {
        productScripts();
      }

      // Re-apply terms state last so it always wins over validate/re-init
      checkbox();
    } catch (error) {
      if (error.name === "AbortError") return;
      console.error("Error fetching the URL:", error);
    } finally {
      setLoadingState(sourceRadio, false);
      activeRequestController = null;
      isFetching = false;
    }
  }

  if (psuedoform.dataset.psuedoVariantsBound === "true") return;
  psuedoform.dataset.psuedoVariantsBound = "true";

  psuedoform.addEventListener("change", function (event) {
    const radio = event.target.closest(".product-option-row__item__radio--psuedo");
    if (!radio || radio.disabled) return;

    const nextUrl = radio.dataset.linkedUrl;
    const nextAbsoluteUrl = nextUrl ? new URL(nextUrl, window.location.origin).toString() : "";
    if (!nextAbsoluteUrl || isFetching || nextAbsoluteUrl === window.location.href) return;

    sessionStorage.setItem("previousUrl", window.location.href);

    const parentList = radio.closest("ul");
    if (parentList) {
      parentList
        .querySelectorAll(".product-option-row__item__radio--psuedo.is-active")
        .forEach((input) => input.classList.remove("is-active"));
    }

    radio.classList.add("is-active");
    radio.checked = true;

    redirectPsuedo(nextAbsoluteUrl, { sourceRadio: radio });
  });

  if (!window.__psuedoVariantsPopstateHandler) {
    window.__psuedoVariantsPopstateHandler = function (event) {
      const nextUrl = event.state?.psuedoUrl || window.location.href;
      redirectPsuedo(nextUrl, { pushState: false });
    };

    window.addEventListener("popstate", window.__psuedoVariantsPopstateHandler);
  }
}


async function ajaxTagFilter() {
  const gallerySection = document.querySelector("section.gallery");
  const filterContainer = document.querySelector(".custom-filter");

  if (!gallerySection || !filterContainer) return;

  const currentPathSearch = `${window.location.pathname}${window.location.search}`;
  window.__galleryLastPathSearch = currentPathSearch;

  if (!window.__galleryPopstateHandler) {
    window.__galleryPopstateHandler = function () {
      const nextPathSearch = `${window.location.pathname}${window.location.search}`;

      // Ignore history changes that only affect hash (e.g. Fancybox open/close).
      if (window.__galleryLastPathSearch === nextPathSearch) return;

      if ( 
        typeof Fancybox !== "undefined" &&
        typeof Fancybox.getInstance === "function" &&
        Fancybox.getInstance()
      ) {
        return;
      }

      window.__galleryLastPathSearch = nextPathSearch;

      const liveGallerySection = document.querySelector("section.gallery");
      if (!liveGallerySection) return;

      fetch(window.location.href)
        .then((response) => response.text())
        .then((data_2) => {
          let parser = new DOMParser(),
            html = parser.parseFromString(data_2, "text/html");

          let newGallery = html.querySelector("section.gallery");

          if (newGallery) {
            liveGallerySection.innerHTML = newGallery.innerHTML;
            document.dispatchEvent(new CustomEvent("gallery:updated"));
          }
        })
        .catch((error) => console.error("Error fetching the URL:", error));
    };

    window.addEventListener("popstate", window.__galleryPopstateHandler);
  }

  if (filterContainer.dataset.ajaxTagFilterBound === "true") return;
  filterContainer.dataset.ajaxTagFilterBound = "true";

  filterContainer.addEventListener("click", async function (event) {
      const link = event.target.closest("a.custom-filter__list__item--link");
      if (!link) return;

      if (link.classList.contains("is-active")) return;

      event.preventDefault();

      const url = link.href;

      // Apply is-active immediately (optimistic), excluding the facets toggle
      document.querySelectorAll("a.custom-filter__list__item--link").forEach((item) => {
        item.classList.remove("is-active");
      });
      link.classList.add("is-active");

      try {
        const response = await fetch(url);
        if (!response.ok) {
          console.error(`HTTP error! status: ${response.status}`);
        }
        const data_2 = await response.text();

        let parser = new DOMParser(),
          html = parser.parseFromString(data_2, "text/html");

        let newGallery = html.querySelector("section.gallery");
        // Update the gallery — server HTML already carries correct is-active from Liquid
        if (newGallery) {
          gallerySection.innerHTML = newGallery.innerHTML;
          gallerySection.classList.add("is-filtered");
          gallerySection.style.animation = "none";
          runScripts();
          document.dispatchEvent(new CustomEvent("gallery:updated"));
        }
      } catch (error) {
        console.error("Error fetching the URL:", error);
      }

      // Update the URL in the browser
      window.history.pushState({ source: "gallery-filter" }, "", url);
      window.__galleryLastPathSearch = `${window.location.pathname}${window.location.search}`;
  });
}





function pdpZoom() {
  // Unbind any existing Fancybox instances first to prevent duplicates
  Fancybox.unbind('[data-fancybox="zoom"]');
  
  Fancybox.bind('[data-fancybox="zoom"]', {
    groupAttr: false,
    Thumbs: false,
    Toolbar: {
      display: false,
    },
    Images: {
      initialSize: "fit",
    },
    on: {
      open:() => {
        console.log("Zoom opened");
        document.querySelector("img.gallery-media").classList.remove("animate--fadeIn");
      },
      close: () => {
        console.log("Zoom closed");
      }
    }
  });
}





function readMoreButton(button) {
  let buttonParent = button.parentNode;
  console.log(buttonParent);

  button.addEventListener("click", function (event) {
    event.preventDefault();
    console.log("click");

    buttonParent.classList.toggle("is-open");
    
    buttonParent
      .querySelector(".read-more-description .description-full")
      .classList.toggle("visually-hidden");
    button.textContent = buttonParent.classList.contains("is-open")
      ? "Read less"
      : "Read more";
  });
}

var extendedDescription =
  document.querySelector(".description-short_description") !== null;

function fixedAddToCart() {
  let formContainer = document.querySelector(".product-main__info");

  let observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          entry.target
            .querySelector(".js-fix-on-scroll")
            .classList.remove("js-fixed");
          html.classList.remove("fixed-add-to-cart");
        } else {
          entry.target
            .querySelector(".js-fix-on-scroll")
            .classList.add("js-fixed");
          html.classList.add("fixed-add-to-cart");
        }
      });
    },
    {
      threshold: [0, 0.1, 1],
    }
  );

  console.log("Fix cart");

  observer.observe(formContainer);
}

function fixedAddToCartMobile() {
  let formContainer = document.querySelector(".product-main__info"),
    trigger = document.querySelector(".recommendations-inline");

  let observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          let form = entry.target.querySelector(".js-fix-on-scroll");
          form.classList.remove("js-fixed");

          html.classList.remove("fixed-add-to-cart");
        } else {
          let form = entry.target.querySelector(".js-fix-on-scroll");
          form.classList.add("js-fixed");
          html.classList.add("fixed-add-to-cart");
        }
      });
    },
    {
      threshold: [0, 0.1, 1],
    }
  );

  console.log("Fix cart");

  observer.observe(formContainer);
}

function onFilterClick(filter) {
  filter.addEventListener("click", function (event) {
    if (html.classList.contains("filter-active")) {
      html.classList.remove("filter-active");
    } else {
      html.classList.add("filter-active");
    }
  });
}

function onSearchButtonClick(button) {
  // console.log("onSearchButtonClick called for button:", button);

  let root = document.documentElement,
  cartCheck = root.classList.contains("mini-cart-open"),
  mobileMenuCheck = root.classList.contains("menu-active"),
  miniCartContents = root.querySelector(".mini-cart .cart-contents"),
  emptyCartCheck = miniCartContents ? miniCartContents.classList.contains("cart-contents--empty") : true,
      header = document.querySelector("header");

  button.addEventListener("click", function (event) {
    event.preventDefault();

    let searchInput = document.querySelector(".js-search-input");

    if (isHeaderTransparent) {
      wasTransparent = true;
    } else {
      wasTransparent = false;
    }

    if (
      (isMenuOpen || isMiniCartOpen)
    ) {
      if (isMenuOpen) {
        console.log("Mobile menu is open, closing and opening search");
        root.classList.remove("menu-active");
        isMenuOpen = false;
      } else if (isMiniCartOpen) {
        console.log("Mini cart is open, closing and opening search");
        root.classList.remove("mini-cart-open");
        isMiniCartOpen = false;
      }
      root.classList.add("search-active");
      button.setAttribute("aria-expanded", true);
      button.setAttribute("aria-label", "Close Search");
      if (wasTransparent) {
        if (header) header.classList.remove("transparent--visible");
      }

      if (searchInput) {
        searchInput.focus();
      }
      isSearchOpen = true;
    } else if (!isSearchOpen) {
      root.classList.add("search-active");
      button.setAttribute("aria-expanded", true);
      button.setAttribute("aria-label", "Close Search");

      if (wasTransparent) {
        if (header) header.classList.remove("transparent--visible");
      }
      if (searchInput) {
        searchInput.focus();
      }
      isSearchOpen = true;
    } else if (isSearchOpen) {
      root.classList.remove("search-active");
      button.setAttribute("aria-expanded", false);
      button.setAttribute("aria-label", "Click to open Search");
      if (wasTransparent) {
        if (header) header.classList.add("transparent--visible");
      }
      isSearchOpen = false;
    }
  });
}


function searchModal() {
  const root = document.documentElement;
  const searchModalElement = document.getElementById("search-modal");
  const searchButtons = Array.from(document.querySelectorAll(".js-search"));
  const header = document.querySelector("header");
  const miniCartElement = document.getElementById("mini-cart");
  const miniCartButtons = Array.from(document.querySelectorAll(".js-cart"));

  if (!searchModalElement || !searchButtons.length) return;

  function syncSearchAria(isOpen) {
    searchModalElement.setAttribute("aria-hidden", String(!isOpen));

    searchButtons.forEach((button) => {
      button.setAttribute("aria-expanded", String(isOpen));

      if (!button.classList.contains("search-modal__close")) {
        button.setAttribute("aria-label", isOpen ? "Close Search" : "Open Search");
      }
    });
  }

  function closeSearchModal() {
    root.classList.remove("search-active");
    syncSearchAria(false);

    if (wasTransparent && header) {
      header.classList.add("transparent--visible");
    }

    isSearchOpen = false;
  }

  function openSearchModal() {
    const searchInput = document.querySelector(".js-search-input");

    if (isHeaderTransparent) {
      wasTransparent = true;
    } else {
      wasTransparent = false;
    }

    if (isMenuOpen) {
      root.classList.remove("menu-active");
      isMenuOpen = false;
    }

    if (isMiniCartOpen) {
      root.classList.remove("mini-cart-open");
      if (miniCartElement) {
        miniCartElement.setAttribute("aria-hidden", "true");
      }
      miniCartButtons.forEach((button) => {
        button.setAttribute("aria-expanded", "false");
        button.setAttribute("aria-label", "Open cart");
      });
      isMiniCartOpen = false;
    }

    root.classList.add("search-active");
    syncSearchAria(true);

    if (wasTransparent && header) {
      header.classList.remove("transparent--visible");
    }

    if (searchInput) {
      searchInput.focus();
    }

    isSearchOpen = true;
  }

  searchButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();

      if (isSearchOpen) {
        closeSearchModal();
      } else {
        openSearchModal();
      }
    });
  });

  searchModalElement.addEventListener("click", function (event) {
    if (event.target === searchModalElement && isSearchOpen) {
      closeSearchModal();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && isSearchOpen) {
      closeSearchModal();
    }
  });

  syncSearchAria(isSearchOpen);
}


let searchLinks = document.querySelectorAll(".js-search");

function getSearchTypeInput(form) {
  return form.querySelector('.js-search-type') || form.querySelector('input[name="type"]');
}

function parseTagList(inputValue) {
  return inputValue
    .split(',')
    .map((tag) => tag.trim().toLowerCase().replace(/\s+/g, '-'))
    .filter(Boolean);
}

function buildTagToken(tag) {
  return `tag:'${tag}'`;
}

function hasActiveTagFilters(form) {
  const includeInput = form.querySelector('.js-search-include-tags');
  const excludeInput = form.querySelector('.js-search-exclude-tags');
  const hasInclude = includeInput && includeInput.value.trim().length > 0;
  const hasExclude = excludeInput && excludeInput.value.trim().length > 0;
  return Boolean(hasInclude || hasExclude);
}

function updateSearchSubmitState(form) {
  const button = form.querySelector('.js-search-submit');
  if (!button) return;

  const termInput = form.querySelector('.js-search-input');
  const typeInput = getSearchTypeInput(form);

  const termValue = termInput ? termInput.value.trim() : '';
  const hasTypes = !typeInput || typeInput.value.length > 0;
  const hasSearchInput = termValue.length > 0 || hasActiveTagFilters(form);
  const shouldDisableButton = !hasSearchInput || !hasTypes;

  if (shouldDisableButton) {
    button.setAttribute('disabled', true);
    button.classList.add('btn-disabled');
    button.classList.add('opacity-025');
  } else {
    button.classList.remove('btn-disabled');
    button.classList.remove('opacity-025');
    button.removeAttribute('disabled');
  }
}

// Search Form
class SearchForm {
  constructor(target) {
    const form = target.closest('form');
    if (!form) return;

    form.addEventListener('keyup', this.onSearchInputKeyUp.bind(this));
    form.addEventListener('change', this.onSearchInputKeyUp.bind(this));
  }

  onSearchInputKeyUp(event) {
    const form = event.target.closest('form');
    if (!form) return;
    updateSearchSubmitState(form);
  }
}
 
function onSearchChange() {

  const forms = document.querySelectorAll('.form-search');
  if (!forms.length) return;

  forms.forEach((form) => {

  const searchScopeSelect = form.querySelector('.js-search-scope');
  const searchOptions = form.querySelectorAll('input.search-option');
  const hiddenInput = getSearchTypeInput(form);
  const unavailableProductsInput = form.querySelector('.js-search-unavailable-products');

  const searchInput = form.querySelector('.js-search-input');
  const includeTagsInput = form.querySelector('.js-search-include-tags');
  const excludeTagsInput = form.querySelector('.js-search-exclude-tags');

  function getSelectedScope() {
    if (searchScopeSelect) {
      return searchScopeSelect.options[searchScopeSelect.selectedIndex] || null;
    }
    return form.querySelector('input.search-option:checked');
  }

  function selectScope(value) {
    if (searchScopeSelect) {
      const hasOption = Array.from(searchScopeSelect.options).some((option) => option.value === value);
      if (!hasOption) return false;
      searchScopeSelect.value = value;
      return true;
    }

    const targetOption = form.querySelector(`input.search-option[value="${value}"]`);
    if (!targetOption) return false;
    targetOption.checked = true;
    return true;
  }

  function syncScopeFromUrl() {
    if (typeof window === 'undefined') return;

    const params = new URLSearchParams(window.location.search);
    const searchScopeParam = (params.get('search_scope') || '').toLowerCase();
    const qParam = (params.get('q') || '').toLowerCase();
    const typeParam = (params.get('type') || '').toLowerCase();
    const scopeTagParam = (params.get('scope_tag') || '').toLowerCase();

    if (searchScopeParam === 'gallery') {
      selectScope('gallery');
      return;
    }

    if (searchScopeParam === 'builder') {
      selectScope('builder');
      return;
    }

    if (scopeTagParam === 'gallery-item') {
      selectScope('gallery');
      return;
    }

    if (scopeTagParam === 'builder-item') {
      selectScope('builder');
      return;
    }

    if (/(?:^|\s)tag:(?:'gallery-item'|gallery-item)(?:\s|$)/i.test(qParam)) {
      selectScope('gallery');
      return;
    }

    if (/(?:^|\s)tag:(?:'builder-item'|builder-item)(?:\s|$)/i.test(qParam)) {
      selectScope('builder');
      return;
    }

    if (typeParam === 'article') {
      selectScope('journal');
      return;
    }

    if (typeParam === 'page') {
      selectScope('pages');
      return;
    }

    if (typeParam === 'product,page,article') {
      selectScope('all');
    }
  }

  function hydrateTagInputsFromSearchTerms() {
    if (!searchInput || !includeTagsInput || !excludeTagsInput) return;

    const includeTags = [];
    const excludeTags = [];
    const searchValue = searchInput.value || '';
    const selectedScope = getSelectedScope();
    const requiredTag = selectedScope ? selectedScope.dataset.requiredTag : '';

    searchValue.replace(/(?:^|\s)(-?)tag:(?:'([^']+)'|([^\s]+))/gi, (_, prefix, quotedTag, unquotedTag) => {
      const normalizedTag = (quotedTag || unquotedTag || '').trim();
      if (!normalizedTag) return '';
      if (prefix === '-') {
        excludeTags.push(normalizedTag);
      } else if (requiredTag && normalizedTag === requiredTag) {
        // Scope-level required tags are represented by the selected scope button.
      } else {
        includeTags.push(normalizedTag);
      }
      return '';
    });

    if (includeTags.length || excludeTags.length) {
      searchInput.value = searchValue.replace(/(?:^|\s)-?tag:[^\s]+/gi, ' ').replace(/\s+/g, ' ').trim();
      includeTagsInput.value = includeTags.join(', ');
      excludeTagsInput.value = excludeTags.join(', ');
    }
  }

  function updateHiddenInput() {
    if (!hiddenInput) return;

    const selectedScope = getSelectedScope();
    if (selectedScope) {
      hiddenInput.value = selectedScope.dataset.searchType || '';

      if (unavailableProductsInput) {
        unavailableProductsInput.value = selectedScope.value === 'gallery' ? 'show' : 'last';
      }
    } else {
      hiddenInput.value = '';

      if (unavailableProductsInput) {
        unavailableProductsInput.value = 'last';
      }
    }

    updateSearchSubmitState(form);
  }

  if (searchScopeSelect) {
    searchScopeSelect.addEventListener('change', () => {
      updateHiddenInput();
    });
  } else {
    searchOptions.forEach((option) => {
      option.addEventListener('change', () => {
        updateHiddenInput();
      });
    });
  }

  if (includeTagsInput) {
    includeTagsInput.addEventListener('input', () => updateSearchSubmitState(form));
  }

  if (excludeTagsInput) {
    excludeTagsInput.addEventListener('input', () => updateSearchSubmitState(form));
  }

  form.addEventListener('submit', () => {
    if (!searchInput) return;

    const hiddenQueryInput = form.querySelector('.js-search-query-hidden');
    if (hiddenQueryInput) {
      hiddenQueryInput.remove();
    }

    searchInput.name = 'q';
  });

  syncScopeFromUrl();
  if (searchInput) {
    searchInput.value = searchInput.value
      .replace(/(?:^|\s)tag:(?:'builder-item'|'gallery-item'|builder-item|gallery-item)(?=\s|$)/gi, ' ')
      .replace(/(?:^|\s)scope:(?:builder|gallery)(?=\s|$)/gi, ' ')
      .replace(/(?:^|\s)tag:(?=\s|$)/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Run once on page load to set the initial value
  updateHiddenInput();
  });
}

  










const productGrid = document.getElementById("product-grid");
const articleGrid = document.getElementById("blog-grid");

function infScroll(container, append) {
  let parent = container.parentNode,
    pagination = parent.querySelector(".pagination"),
    viewMore = document.querySelector(".view-more");

  if (pagination !== null) {
    console.log("pagination exists");

    let infScrollActive = pagination.getAttribute("data-inf-scroll");

    if (infScrollActive === "true") {
      console.log("infinite scroll active");

      let viewMoreText = viewMore.querySelector(".view-more__button");
      viewMore.classList.remove("visually-hidden"); // show view more button
      console.log("display view more button");

      infiniteScroll = new InfiniteScroll(container, {
        // options
        hideNav: ".pagination",
        scrollThreshold: false,
        path: ".pagination__step.next",
        append: append,
        // history: true,
        // historyTitle: true,
        button: ".view-more__button",
        scrollThreshold: false,
        onInit: function () {
          this.on("load", function () {
            console.log("Infinite Scroll load");
          });
          this.on("request", function () {
            console.log("Infinite Scroll request");
            viewMoreText.textContent = "Loading…";
          });
          this.on("append", function (body, path, items, response) {
            console.log("Infinite Scroll append path - " + path);
            console.log("Infinite Scroll append length - " + items.length);
            console.log("Infinite Scroll append response - " + response.status);
            intObs();
            viewMoreText.textContent = "View More";
          });
          this.on("error", function () {
            console.log("Infinite Scroll error");
          });
        },
      });
    } else {
      console.log("infinite scroll disabled in settings");
      return;
    }
  } else {
    console.log("no pagination");
  }
}

let isHeaderTransparent = false;

indexTransparentHeader = () => {
  let header = document.querySelector("header"),
    hero = document.querySelector("section.hero"),
    transparentCheck = header.classList.contains("transparent"),
    megamenu = document.querySelector(".megamenu"),
    search = document.querySelector(".header-search"),
    miniCartCheck = document.querySelector(".mini-cart.open") !== null;

  if (transparentCheck) {
    let lastKnownState = null;

    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          let isTransparent = entry.intersectionRatio > 0.25;
          if (lastKnownState !== isTransparent) {
            lastKnownState = isTransparent;
            if (isTransparent) {
              header.classList.add("transparent--visible");
              // console.log("header is transparent");
            } else {
              header.classList.remove("transparent--visible");
              // console.log("header is not transparent");
            }
          }
        });
      },
      {
        threshold: 0.25,
      }
    );

    observer.observe(hero);

    header.addEventListener("mouseover", function () {
      header.classList.remove("transparent--visible");
      isHeaderTransparent = false;
    });

    header.addEventListener("mouseleave", function () {
      if (lastKnownState && !isMiniCartOpen) {
          header.classList.add("transparent--visible");
          isHeaderTransparent = true;
          wasTransparent = true;
      }
    });

    if (megamenu) {
      megamenu.addEventListener("mouseover", function () {
        header.classList.remove("transparent--visible");
        megamenu.setAttribute("aria-expanded", true);
        isHeaderTransparent = false;
      });

      megamenu.addEventListener("mouseleave", function () {
        if (lastKnownState) {
          header.classList.add("transparent--visible");
          isHeaderTransparent = true;
        }
      });
      
    }
  }
};





function infScrollReset() {
  console.log("reset inf scroll");
  let append = "li.product-card";

  if (typeof infiniteScroll !== "undefined" && infiniteScroll !== null) {
    infiniteScroll.destroy();
  } else {
    console.log("infiniteScroll is not defined");
    return;
  }

  if (productGrid) {
    console.log("product grid");
    let latestProductGrid = document.querySelector(
      "#ProductGridContainer #product-grid"
    );
    append = "li.product-card";
    infScroll(latestProductGrid, append);
  } else if (articleGrid) {
    console.log("article grid");
    let latestArticleGrid = document.querySelector("#article-grid");
    append = "li.article-card";
    infScroll(latestArticleGrid, append);
    intObs();
  } else {
    console.log("no grids");
  }
}

// Announcement Bar
function annBar() {
  let annBar = document.querySelector(".announcement-bar"),
    annClose = document.querySelector(".announcement-bar .js-close"),
    slider = document.querySelector(".announcement-bar__carousel"),
    html = document.querySelector("html"),
    bannerCheck = html.classList.contains("show-banner");

  if (sessionStorage.hasOwnProperty("annHide")) {
    console.log("banner previously hidden");
    html.classList.remove("show-banner");
    annBar.style.display = "none";
  } else {
    if (bannerCheck) {
      // html.classList.add('show-banner')
      // console.log("banner already showing");

      if (slider) {
        var flkty = new Flickity(slider, {
          wrapAround: true,
          prevNextButtons: false,
          cellSelector: ".announcement-bar__cell",
          autoPlay: 4000,
          pageDots: false,
          setGallerySize: false,
          draggable: false,
          fade: true,
        });
      }

      annClose.addEventListener("click", function (event) {
        event.preventDefault();

        html.classList.remove("show-banner");
        annBar.style.display = "none";

        window.sessionStorage.setItem("annHide", "true");
        window.sessionStorage.setItem("origin", "https://varana.com");
      });
    }
  }
}

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Hero Carousel

function heroCarousel(slider) {
  var heroFlkty = new Flickity(slider, {
    wrapAround: true,
    prevNextButtons: false,
    cellSelector: ".hero__media--slide",
    autoPlay: 4000,
    pageDots: false,
    setGallerySize: false,
    draggable: false,
    fade: true,
  });

  heroFlkty.on("change", function (index) {
    var video = heroFlkty.selectedElement.querySelector("video");

    if (video) {
      video.play();
    } else {
      slider.querySelectorAll("video").forEach((video) => {
        video.pause();
      });
    }
  });
}
const heroCarouselEl = ".hero--carousel";
const heroCarouselCheck = document.querySelector(heroCarouselEl) !== null;

if (heroCarouselCheck) {
  document.querySelectorAll(heroCarouselEl).forEach((slider) => {
    heroCarousel(slider);
  });
}



// Product Modal

function productModal() {
  console.log("productModal called");
  let productModalSelector = 'productModal',
      productModal = document.getElementById(productModalSelector);

  if (!productModal || typeof MicroModal === "undefined") return;

  // Re-init trigger bindings so modal links keep working after section re-renders.
  MicroModal.init({
    openClass: "is-open",
    debugMode: true,
  });

  if (sessionStorage.getItem("modalClosed")) {
    console.log("Modal was previously closed, not showing again");
    return;
  }

  // Initialize and show in one call with options 
  MicroModal.show(productModalSelector, {
    onClose: (modal) => {
      modal.querySelector(".product-modal__container").classList.remove("animate--moveIn");
      sessionStorage.setItem("modalClosed", true);
      console.log(`${modal.id} is closed`);
      runScripts();
    },
    openClass: "is-open",
    debugMode: true
  });
}







//  Collection / Search scripts

collectionScripts = () => {
  // Filter
  let filterLinks = document.querySelectorAll(".js-filter-toggle");
  console.log("collectionScripts called");
  removeActiveClass(document.querySelector("section.gallery"));
  filterLinks.forEach((link) => {
    onFilterClick(link);
  });
  // Infinite Scroll

  // Infinite Scroll - Checks for pagination and appends to the grid
  // if (productGrid) {
  //   let latestProductGrid = document.querySelector("#product-grid"),
  //     append = "li.product-card";

  //   infScroll(latestProductGrid, append);
  // }
};

// Product scripts

productScripts = () => {
  // Product Recommendations
  reccs();
  pdpZoom();
  psuedoVariants(); 
  productModal(); 
  // Read More Button
  // if (extendedDescription) {
  //   let buttons = document.querySelectorAll(".js-read-more");
  //   buttons.forEach((button) => {
  //     readMoreButton(button);
  //   });
  // }

  // Fixed Add to Cart
  var fixedFormCheck = document.querySelector(".js-fix-on-scroll");

  if (fixedFormCheck && !px800) {
    fixedAddToCart();
  } else if (fixedFormCheck && px800) {
    fixedAddToCartMobile();
  }
};

repeatScripts = () => {
  console.log("repeat scripts");

  // Scripts that need to be re-run on window resize, infinite scroll etc.
};

universalScripts = () => {
  // Toggle Expanded
  toggleExpandedEls(); 
  mobileMenuClass()
  quickAddCloseListener();
  // Intersection Observer
  intObs();
  checkedToCheckbox()
  indexTransparentHeader();

  if (annBarCheck) {
    annBar();
  }

  miniCart()

  // Read More Button
  if (extendedDescription) {
    let buttons = document.querySelectorAll(".js-read-more");
    buttons.forEach((button) => {
      readMoreButton(button);
    });
  }

  // Search Form
  let searchInput = document.querySelectorAll(".js-search-input");
  searchInput.forEach((search) => {
    new SearchForm(search);
  });

  // Search Modal
  searchModal();
  onSearchChange();
};

blogScripts = () => {
  // Infinite Scroll
    blogFilter()

  // if (articleGrid) {
  //   console.log("article grid");
  //   let latestArticleGrid = document.querySelector("#blog-grid");
  //   append = "li.article-card"; 
  //   infScroll(latestArticleGrid, append);
  // }
};

// All Scripts
runScripts = () => {
  console.log("run scripts");
  universalScripts();
  if (productCheck) {
    productScripts();
  } else if (galleryCheck) {
    ajaxTagFilter();
  } else if (collectionCheck || searchCheck || galleryCheck) {
    collectionScripts();
  } else if (blogCheck) {
    blogScripts();
  }
};

runScripts();


// Run scripts on window resize
window.addEventListener("resize", runScripts);


